import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { SCENARIO_API_URL } from "../../../config";
import { ModelScenario } from "../types";

export const useModelScenario = (scenario_id: string) => {
  return useQuery({
    queryKey: ["client", "model", "scenarios", scenario_id],
    enabled: scenario_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${SCENARIO_API_URL}/waves-scenario-manager-api/v1/scenarios/${scenario_id}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelScenario;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
